export default "__VITE_ASSET__2be06d17__"